var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#467a3c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "rgb(255, 255, 255)",
    transform: "matrix(1,0,0,1,3,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 4.9 c 0 -0.3 0.2 -0.5 0.5 -0.5 h 9.2 C 9.9 4.4 10 4.5 10.1 4.7 C 10.2 4.8 10.2 5 10.1 5.2 C 10 5.3 9.9 5.4 9.7 5.4 H 0.5 C 0.2 5.4 0 5.2 0 4.9 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveGreenIcon);
export default __webpack_public_path__ + "static/media/remove-green-icon.7a330619e8b7412f4248da240e7c3585.svg";
export { ForwardRef as ReactComponent };